var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgInfoIcon = function SvgInfoIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 14,
    viewBox: "0 0 13 14",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    opacity: 0.23,
    d: "M6.5 0.5C2.91023 0.5 0 3.41023 0 7C0 10.5898 2.91023 13.5 6.5 13.5C10.0898 13.5 13 10.5898 13 7C13 3.41023 10.0898 0.5 6.5 0.5ZM6.97568 3.12955C7.42182 3.12955 7.79704 3.47818 7.79704 3.93909C7.79704 4.4 7.42182 4.74864 6.97568 4.74864C6.52955 4.74864 6.15432 4.4 6.15432 3.93909C6.15432 3.47818 6.52955 3.12955 6.97568 3.12955ZM7.96841 9.60591C7.59909 10.6045 7.04068 10.8705 6.41136 10.8705C5.59 10.8705 5.20591 10.4007 5.20591 9.68864C5.20591 9.50841 5.22955 9.30159 5.27682 9.09773L5.8175 6.89955C5.85886 6.73409 5.7525 6.59818 5.58114 6.59818H5.24727C5.07591 6.59818 4.9725 6.46523 5.01682 6.29977L5.14977 5.78864C5.19409 5.62318 5.36545 5.49023 5.53682 5.49023H7.21205C7.38341 5.49023 7.48682 5.62614 7.44545 5.79159L6.61523 9.08886C6.55614 9.31932 6.52955 9.51136 6.52955 9.64432C6.52955 9.87182 6.63886 9.98409 6.81909 9.98409C7.00523 9.98409 7.19727 9.88659 7.41591 9.40205C7.48682 9.24545 7.64932 9.15977 7.79704 9.21886C7.94477 9.26614 8.0275 9.44636 7.96841 9.60591Z",
    fill: "#002E5C"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgInfoIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/InfoIcon.5c960cba.svg";
export { ForwardRef as ReactComponent };